import { KEY_SEPARATOR } from './constants';
import { getLanguage } from './locale';
import { getPluralName } from './plurals';
import type { PhraseMap } from './types';

/**
 * Returns the raw string for the specified key. If the string is not found, returns empty string.
 *
 * @param key String key.
 * @param count Optional value used to determine plural variant of the key.
 */
type Lookup = (locale: string, phrases: PhraseMap, key: string, count?: number) => string;
export const lookup: Lookup = (locale, phrases, key, count) => {
  if (!key) {
    return '';
  }

  const pluralName = getPluralName(count, getLanguage(locale));

  const fullKey = pluralName ? [key, pluralName].join(KEY_SEPARATOR) : key;

  return phrases[fullKey] ?? '';
};
